import React from 'react';
import { NavigateBefore } from '@mui/icons-material';

import Divider from '@mui/material/Divider';
import Items from './items';
import User from './user';
import Toggle from './toggle';

function SideMenu() {
  return (
    <div className="flex flex-col min-h-full justify-around align-center relative h-full text-zinc-800 font-light ">
      <div className="h-16 mb-3 flex items-center justify-center p-3">
        <img className="" src="/assets/images/logo--dark.png" alt="logo" />
      </div>
      <User />
      <div className="grow shrink overflow-auto">
        <Items />
      </div>
      <div className="absolute right-0 bottom-4">
        <Toggle />
      </div>
    </div>
  );
}

export default SideMenu;
